import {
  AttributeService,
  AuthenticationState,
  LoginService,
} from "@edtell-common";
import { Component, NgZone } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Params, Router } from "@angular/router";
import { agGridKey } from "../../environments/environment";
import { LicenseManager } from "ag-grid-enterprise";
import { EdtellLocationService } from "../modules/edtell-common/edtell-portal/services/edtell-location.service";
import { filter, map } from "rxjs/operators";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  constructor(
    private ngZone: NgZone,
    private router: Router,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private attributeService: AttributeService,
    private edtellLocationService: EdtellLocationService,
  ) {
    this.setAgGridLicenseKey();

    this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.route),
        map((route) => {
          while (route.firstChild && route.snapshot?.data.htmlProperty == null) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary')
      )
      .subscribe((route) => {
        let htmlElement = document.getElementsByTagName('html')[0]
        if (route.snapshot?.data.htmlProperty == 'large-font') {
          htmlElement.classList.add('large-font')
        }
        else {
          htmlElement.classList.remove('large-font')
        }
      });

    this.loginService.loginState.subscribe((e) => {
      if (e.redirect == null || e.redirect == false) {
        return;
      }

      if (e.state != AuthenticationState.AUTHENTICATED) {
        this.login();
      } else {
        this.home();
      }
    });
  }

  login() {
    this.ngZone.run(() => {
      this.router.navigate(["/login"]);
    });
  }

  home() {
    this.ngZone.run(() => {
      let loc = this.edtellLocationService.previous;
      loc =
        loc?.path == null || loc.path == "/login"
          ? { path: "/" }
          : this.edtellLocationService.previous;

      const queryParams: Params = {};
      if (loc.queryParams != null) {
        for (const key of loc.queryParams.keys) {
          queryParams[key] = loc.queryParams.get(key);
        }
      }

      this.router.navigate([loc.path], { queryParams: queryParams });
    });
  }

  private async setAgGridLicenseKey() {
    const agGridLicenseKeyAttribute = await this.attributeService
      .getAgGridLicenseKey()
      .toPromise();
    LicenseManager.setLicenseKey(
      agGridLicenseKeyAttribute
        ? agGridLicenseKeyAttribute.attributeValue
        : agGridKey,
    );
  }
}
